import { render, staticRenderFns } from "./PagBankPremiumAlert.vue?vue&type=template&id=ebe8a2a2"
import script from "./PagBankPremiumAlert.vue?vue&type=script&lang=ts"
export * from "./PagBankPremiumAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports